const {getValueFromObjectByPrefix, menuFromMap, toCamelCase, arrayWithoutDublicates} = require('../utils');
const cssMobile = require('./footer/mobile.scss');
const cssDesktop = require('./footer/desktop.scss');
const {modifyBlogLink, modifyStoriesLink} = require('./common');
const {socialNetworks} = require('../data/constants.json');

const icons = arrayWithoutDublicates([].concat(socialNetworks.mobile, socialNetworks.desktop))
  .reduce((object, name) => Object.assign(object, {[name]: require(`./svg/${name}`).default}), {});

function getSocialLinks(t, tLinks, isMobile) {
  const css = isMobile ? cssMobile : cssDesktop;
  return socialNetworks[isMobile ? 'mobile' : 'desktop'].map(network => ({
    text: icons[network],
    href: tLinks(network),
    classes: `${css.icon} ${css[toCamelCase(`icon-${network}`)]}`,
    contentAttrs: {target: '_blank'}
  }));
}

module.exports = ({map, translations, isMobile, config}) => {
  const t = getValueFromObjectByPrefix(translations, 'footer_');
  const tLinks = getValueFromObjectByPrefix(translations, 'link_');
  const socialLinks = getSocialLinks(t, tLinks, isMobile);
  const mainLinks = menuFromMap(
    map,
    `footer.${isMobile ? 'mobileNav' : 'nav'}`,
    translations,
    config.language,
    [modifyBlogLink, modifyStoriesLink]
  );

  return require(`./footer/${isMobile ? 'mobile' : 'desktop'}`)({mainLinks, socialLinks, t, config});
};



// WEBPACK FOOTER //
// ./templates/footer.js